import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import ChartCard from "./ChartCard";
import {
  CHART_COLORS,
  getChartTheme,
  shortLabel,
} from "../utils/chartTheme";

export default function HorizontalBarChart({
  title,
  data = [],
  dataKey = "value",
  nameKey = "name",
  color = CHART_COLORS.teal,
  height = 300,
  unit,
  isDarkMode = false,
  colorScale,
}) {
  const theme = getChartTheme(isDarkMode);
  const chartH = Math.max(height, Math.min(440, 48 + data.length * 34));
  const rows = data.map((r) => ({
    ...r,
    label: shortLabel(r[nameKey], 18),
  }));

  const tooltipFormatter = (val) =>
    unit != null ? [`${val} ${unit}`, undefined] : [`${val}`, undefined];

  return (
    <ChartCard title={title} empty={!data.length} height={chartH} accent={color}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={rows}
          layout="vertical"
          margin={{ top: 4, right: 20, left: 4, bottom: 4 }}
          barCategoryGap="28%"
        >
          <CartesianGrid {...theme.cartesianProps} horizontal={false} />
          <XAxis
            type="number"
            tick={theme.tickProps}
            axisLine={theme.axisLine}
            tickLine={theme.tickLine}
          />
          <YAxis
            type="category"
            dataKey="label"
            width={118}
            tick={theme.tickProps}
            axisLine={theme.axisLine}
            tickLine={false}
          />
          <Tooltip
            contentStyle={theme.tooltipContentStyle}
            labelStyle={theme.tooltipLabelStyle}
            itemStyle={theme.tooltipItemStyle}
            formatter={tooltipFormatter}
            labelFormatter={(_, payload) =>
              payload?.[0]?.payload?.[nameKey] || ""
            }
            cursor={{
              fill: isDarkMode
                ? "rgba(255,255,255,0.04)"
                : "rgba(29,52,69,0.04)",
            }}
          />
          <Bar dataKey={dataKey} radius={[0, 6, 6, 0]} barSize={14}>
            {rows.map((entry, index) => (
              <Cell
                key={`${entry.label}-${index}`}
                fill={
                  colorScale
                    ? colorScale[index % colorScale.length]
                    : color
                }
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </ChartCard>
  );
}
